export const mapCategoriesToPosts = (posts, categories) => {
    return posts.map((post) => ({
        ...post,
        categoryNames: post.categories.map(
                (categoryId) => categories.find((cat) => cat.id === categoryId)?.name || 'Inconnu'
        ),
    }));
};